var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"siruq"}},[_c('div',{attrs:{"id":"intro"}},[_c('a',{attrs:{"href":"#/intro"}},[_vm._v("しるQとは？"),_c('v-fa',{attrs:{"icon":['fas', 'external-link-alt']}})],1)]),_vm._v(" "),_c('Question'),_vm._v(" "),_c('AnswerBtn'),_vm._v(" "),_c('Twitter'),_vm._v(" "),_c('AnswerBtn')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a14a9a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = null
// module chunks = 